<template>
  <div class="nav-group">
    <button
      class="nav-group__header"
      :class="{ 'nav-group__header--active': isOpen }"
      @click="toggle"
    >
      <div class="nav-group__header-left">
        <UIcon :name="icon" class="w-4 h-4 shrink-0" />
        <span class="nav-group__title">{{ title }}</span>
      </div>
      <UIcon
        name="i-heroicons-chevron-right"
        class="nav-group__chevron w-4 h-4 shrink-0 transition-transform duration-200"
        :class="{ 'rotate-90': isOpen }"
      />
    </button>

    <Transition name="nav-group">
      <div v-if="isOpen" class="nav-group__items">
        <slot />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string
  icon: string
  storageKey: string
  defaultOpen?: boolean
}>()

const isOpen = ref(props.defaultOpen ?? false)

onMounted(() => {
  const savedValue = localStorage.getItem(`admin-nav-${props.storageKey}`)
  if (savedValue !== null) {
    isOpen.value = savedValue === 'true'
  }
})

function toggle() {
  isOpen.value = !isOpen.value
  localStorage.setItem(`admin-nav-${props.storageKey}`, String(isOpen.value))
}
</script>

<style scoped>
.nav-group__header {
  @apply
    w-full flex items-center justify-between
    px-3 py-2 rounded-lg
    text-sm font-semibold text-gray-300
    hover:bg-gray-700 hover:text-white
    transition-colors duration-150 cursor-pointer
    select-none;
}

.nav-group__header--active {
  @apply text-white;
}

.nav-group__header-left {
  @apply flex items-center gap-2;
}

.nav-group__title {
  @apply text-xs uppercase tracking-wider;
}

.nav-group__items {
  @apply pl-3 mt-1 space-y-0.5 border-l border-gray-700 ml-4;
}

/* Transition */
.nav-group-enter-active,
.nav-group-leave-active {
  transition: all 0.2s ease;
  overflow: hidden;
}

.nav-group-enter-from,
.nav-group-leave-to {
  opacity: 0;
  max-height: 0;
}

.nav-group-enter-to,
.nav-group-leave-from {
  opacity: 1;
  max-height: 500px;
}
</style>
